import { delayp0o4nsccwai as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { NativeElementCommonCode2d0djdz0fnra3 as NativeElementCommonCode } from './NativeElement.mjs';
import {
  FutureElement3o36ukl4wk2br as FutureElement,
  nativeSetDragData3rhkgkz3i4r34 as nativeSetDragData,
  nativeOnDrop30134938gsti8 as nativeOnDrop,
  nativeScrollIntoView1t8wmo7ny7ja1 as nativeScrollIntoView,
} from './NativeElement.commonHtml.js.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya3q1gard26whe6 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveNotActive_instanceavp2nits8goa as InternalReactiveNotActive_instance,
  InternalReactiveNotReady_instancer79hznuwejmn as InternalReactiveNotReady_instance,
} from '../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { PassthroughContainertzebc7dblhz6 as PassthroughContainer } from './direct/modifiers.commonHtml.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from './direct/LinearLayouts.commonHtml.mjs';
import {
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  _Dimension___get_value__impl__urhqzrblez9tu1bx9v as _Dimension___get_value__impl__urhqzr,
  Dimensions32ju1l7z4mh as Dimension,
} from '../models/data.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { WeakReferencel11chldcck68 as WeakReference } from '../debugger.js.mjs';
import { checkLeakAfterDelayr9e6vxihbhwn as checkLeakAfterDelay } from '../debugger.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var labelForIdCounter;
function NativeElement$requestFocus$slambda($milliseconds, this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* delay($milliseconds, $completion);
    this$0.native_1.focus_of07w8_k$();
    return Unit_instance;
  }), 1);
}
function Job$cancel$ref(p0) {
  return constructCallableReference(() => {
    p0.cancel$default_8haxne_k$();
    return Unit_instance;
  }, 0, 0, 78, VOID, [p0]);
}
function NativeElement$announceAsNewScreen$slambda($milliseconds, this$0) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* delay($milliseconds, $completion);
    this$0.native_1.focus_of07w8_k$();
    return Unit_instance;
  }), 1);
}
var NativeElementClass;
function NativeElement() {
  if (NativeElementClass === VOID) {
    class $ extends NativeElementCommonCode() {
      constructor(context) {
        super(context);
        var tmp = this;
        // Inline function 'kotlin.also' call
        var this_0 = new (FutureElement())();
        this_0.classes_1.add_utx5q5_k$('kui');
        tmp.native_1 = this_0;
        this.opacity_1 = 1.0;
        this.shown_1 = true;
        this.visible_1 = true;
        this.ignoreInteraction_1 = false;
        this.dragData_1 = null;
        this.dropTargetDelegate_1 = null;
        this.prevThemeClass_1 = null;
        var tmp_0 = this.get_foregroundProcesses_2lrnkf_k$();
        tmp_0.addListener_6y9mct_k$(() => {
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
          var this_0 = this.get_foregroundProcesses_2lrnkf_k$().get_state_wc71uu_k$();
          var tmp;
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.active' call
          if (!equals(_ReactiveState___get_raw__impl__92ipya(this_0), InternalReactiveNotActive_instance)) {
            tmp = !equals(_ReactiveState___get_raw__impl__92ipya(this_0), InternalReactiveNotReady_instance);
          } else {
            tmp = false;
          }
          if (!tmp)
            this.native_1.classes_1.add_utx5q5_k$('working');
          else {
            this.native_1.classes_1.remove_cedx0m_k$('working');
          }
          return Unit_instance;
        });
        this.showOnPrint_1 = true;
      }
      set_opacity_ecw914_k$(value) {
        this.opacity_1 = value;
        var tmp0 = this.native_1.style_1;
        // Inline function 'com.lightningkite.kiteui.views.opacity' call
        var value_0 = value.toString();
        tmp0.native_1.opacity = value_0;
      }
      set_shown_mavbz5_k$(value) {
        this.shown_1 = value;
        var tmp0 = this.native_1.attributes_1;
        // Inline function 'com.lightningkite.kiteui.views.hidden' call
        var value_0 = !value;
        tmp0.native_1.hidden = value_0;
        var tmp = this.get_parent_hy4reb_k$();
        var tmp0_safe_receiver = tmp instanceof PassthroughContainer() ? tmp : null;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.apply' call
          var tmp0_0 = tmp0_safe_receiver.native_1.attributes_1;
          // Inline function 'com.lightningkite.kiteui.views.hidden' call
          var value_1 = !value;
          tmp0_0.native_1.hidden = value_1;
          var tmp_1 = tmp0_safe_receiver.get_parent_hy4reb_k$();
          var tmp0_safe_receiver_0 = tmp_1 instanceof RowOrCol() ? tmp_1 : null;
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            tmp0_safe_receiver_0.rerunOptimizedBottomMarginCalc_6q5hy8_k$();
          }
          tmp_0 = tmp0_safe_receiver;
        }
        if (tmp_0 == null) {
          var tmp_2 = this.get_parent_hy4reb_k$();
          var tmp2_safe_receiver = tmp_2 instanceof RowOrCol() ? tmp_2 : null;
          if (tmp2_safe_receiver == null)
            null;
          else {
            tmp2_safe_receiver.rerunOptimizedBottomMarginCalc_6q5hy8_k$();
          }
        }
      }
      get_shown_iyiju0_k$() {
        return this.shown_1;
      }
      set_visible_w9mvj4_k$(value) {
        this.visible_1 = value;
        var tmp0 = this.native_1.style_1;
        // Inline function 'com.lightningkite.kiteui.views.visibility' call
        var value_0 = value ? 'visible' : 'hidden';
        tmp0.native_1.visibility = value_0;
      }
      get_visible_8zfvk9_k$() {
        return this.visible_1;
      }
      set_ignoreInteraction_ww4hrm_k$(value) {
        this.ignoreInteraction_1 = value;
        if (value)
          this.native_1.classes_1.add_utx5q5_k$('noInteraction');
        else
          this.native_1.classes_1.remove_cedx0m_k$('noInteraction');
      }
      set_debugName_wihv62_k$(value) {
        super.set_debugName_wihv62_k$(value);
        var tmp = this.native_1;
        tmp.setAttribute_j9pxft_k$('data-debug-name', value == null ? '' : value);
      }
      get_debugName_58dolx_k$() {
        return super.get_debugName_58dolx_k$();
      }
      set_accessibleLabel_97wje2_k$(value) {
        super.set_accessibleLabel_97wje2_k$(value);
        this.native_1.setAttribute_j9pxft_k$('aria-label', value);
      }
      get_accessibleLabel_uztlo5_k$() {
        return super.get_accessibleLabel_uztlo5_k$();
      }
      set_accessibleLiveRegion_kq920e_k$(value) {
        super.set_accessibleLiveRegion_kq920e_k$(value);
        switch (value.ordinal_1) {
          case 0:
            this.native_1.setAttribute_j9pxft_k$('aria-live', null);
            break;
          case 1:
            this.native_1.setAttribute_j9pxft_k$('aria-live', 'polite');
            break;
          case 2:
            this.native_1.setAttribute_j9pxft_k$('aria-live', 'assertive');
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
      }
      set_labelFor_go6ca6_k$(value) {
        var previous = super.get_labelFor_6to4xq_k$();
        super.set_labelFor_go6ca6_k$(value);
        if (!(value == null)) {
          var targetNative = value.get_underlyingNativeElement_vngz33_k$().native_1;
          if (targetNative.id_1 == null) {
            var _unary__edvuaz = labelForIdCounter;
            labelForIdCounter = _unary__edvuaz + 1 | 0;
            targetNative.set_id_wyyipr_k$('kiteui-a11y-' + _unary__edvuaz);
          }
          if (this.native_1.tag_1 === 'span' || this.native_1.tag_1 === 'p') {
            this.native_1.tag_1 = 'label';
            this.native_1.setAttribute_j9pxft_k$('for', ensureNotNull(targetNative.id_1));
          } else {
            targetNative.setAttribute_j9pxft_k$('aria-labelledby', ensureNotNull(targetNative.id_1));
          }
        } else {
          if (this.native_1.tag_1 === 'label') {
            this.native_1.setAttribute_j9pxft_k$('for', null);
          } else {
            var tmp1_safe_receiver = previous == null ? null : previous.get_underlyingNativeElement_vngz33_k$();
            var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.native_1;
            if (tmp2_safe_receiver == null)
              null;
            else {
              tmp2_safe_receiver.setAttribute_j9pxft_k$('aria-labelledby', null);
            }
          }
        }
      }
      get_labelFor_6to4xq_k$() {
        return super.get_labelFor_6to4xq_k$();
      }
      set_describedBy_4bf3cf_k$(value) {
        super.set_describedBy_4bf3cf_k$(value);
        if (!(value == null)) {
          var descNative = value.get_underlyingNativeElement_vngz33_k$().native_1;
          if (descNative.id_1 == null) {
            var _unary__edvuaz = labelForIdCounter;
            labelForIdCounter = _unary__edvuaz + 1 | 0;
            descNative.set_id_wyyipr_k$('kiteui-a11y-' + _unary__edvuaz);
          }
          this.native_1.setAttribute_j9pxft_k$('aria-describedby', descNative.id_1);
        } else {
          this.native_1.setAttribute_j9pxft_k$('aria-describedby', null);
        }
      }
      set_dragData_xdzgsz_k$(value) {
        this.dragData_1 = value;
        var tmp0 = this.native_1.attributes_1;
        // Inline function 'com.lightningkite.kiteui.views.draggable' call
        var value_0 = !(value == null);
        tmp0.native_1.draggable = value_0;
        if (!(value == null)) {
          var tmp0_0 = this.native_1.classes_1;
          // Inline function 'kotlin.collections.plusAssign' call
          var element = 'draggable';
          tmp0_0.add_utx5q5_k$(element);
        } else {
          var tmp0_1 = this.native_1.classes_1;
          // Inline function 'kotlin.collections.minusAssign' call
          var element_0 = 'draggable';
          tmp0_1.remove_cedx0m_k$(element_0);
        }
        nativeSetDragData(this, value);
      }
      get_dragData_pas5on_k$() {
        return this.dragData_1;
      }
      set_dropTargetDelegate_92bhjh_k$(value) {
        this.dropTargetDelegate_1 = value;
        nativeOnDrop(this, value);
      }
      get_dropTargetDelegate_fbdv1u_k$() {
        return this.dropTargetDelegate_1;
      }
      refreshPadding_un7dm_k$() {
        if (!(this.paddingByEdge_1 == null) || !(this.safeAreaPadding_1 == null)) {
          var value = this.get_appliedPadding_3m7h7h_k$();
          var tmp0 = this.native_1.style_1;
          // Inline function 'com.lightningkite.kiteui.views.paddingLeft' call
          var value_0 = _Dimension___get_value__impl__urhqzr(value.left_1).toString();
          tmp0.native_1.paddingLeft = value_0;
          var tmp0_0 = this.native_1.style_1;
          // Inline function 'com.lightningkite.kiteui.views.paddingTop' call
          var value_1 = _Dimension___get_value__impl__urhqzr(value.top_1).toString();
          tmp0_0.native_1.paddingTop = value_1;
          var tmp0_1 = this.native_1.style_1;
          // Inline function 'com.lightningkite.kiteui.views.paddingRight' call
          var value_2 = _Dimension___get_value__impl__urhqzr(value.right_1).toString();
          tmp0_1.native_1.paddingRight = value_2;
          var tmp0_2 = this.native_1.style_1;
          // Inline function 'com.lightningkite.kiteui.views.paddingBottom' call
          var value_3 = _Dimension___get_value__impl__urhqzr(value.bottom_1).toString();
          tmp0_2.native_1.paddingBottom = value_3;
        } else {
          // Inline function 'com.lightningkite.kiteui.views.paddingLeft' call
          this.native_1.style_1.native_1.paddingLeft = null;
          // Inline function 'com.lightningkite.kiteui.views.paddingTop' call
          this.native_1.style_1.native_1.paddingTop = null;
          // Inline function 'com.lightningkite.kiteui.views.paddingRight' call
          this.native_1.style_1.native_1.paddingRight = null;
          // Inline function 'com.lightningkite.kiteui.views.paddingBottom' call
          this.native_1.style_1.native_1.paddingBottom = null;
        }
      }
      scrollIntoView_zcj1gb_k$(horizontal, vertical, animate) {
        return nativeScrollIntoView(this, horizontal, vertical, animate);
      }
      requestFocus_9180nb_k$() {
        this.native_1.setAttribute_j9pxft_k$('autofocus', 'true');
        // Inline function 'com.lightningkite.kiteui.afterTimeout' call
        var job = launch(this, VOID, VOID, NativeElement$requestFocus$slambda(100n, this));
        Job$cancel$ref(job);
      }
      announceAsNewScreen_hgpm93_k$(title) {
        this.native_1.setAttribute_j9pxft_k$('tabindex', '-1');
        // Inline function 'com.lightningkite.kiteui.afterTimeout' call
        var job = launch(this, VOID, VOID, NativeElement$announceAsNewScreen$slambda(16n, this));
        Job$cancel$ref(job);
      }
      leakDetect_rzp4wm_k$() {
        checkLeakAfterDelay(new (WeakReference())(this.native_1), 1000n);
        var tmp0_safe_receiver = this.native_1.get_actualElementForLeakTracking_nchncy_k$();
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          checkLeakAfterDelay(new (WeakReference())(tmp0_safe_receiver), 1000n);
        }
      }
      nativeApplyTheme_6heplg_k$(theme) {
        if (theme.drawBackground_1) {
          this.native_1.classes_1.add_utx5q5_k$('transition');
        } else {
          this.native_1.classes_1.remove_cedx0m_k$('transition');
        }
        if (theme.padding_1) {
          this.native_1.classes_1.add_utx5q5_k$('padded');
        } else {
          this.native_1.classes_1.remove_cedx0m_k$('padded');
        }
        var tmp0_safe_receiver = this.prevThemeClass_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          this.native_1.classes_1.remove_cedx0m_k$(tmp0_safe_receiver);
        }
        var newClass = this.get_context_h02k06_k$().kiteUiCss_1.themeInteractive_19n8xp_k$(theme.theme_1);
        this.prevThemeClass_1 = newClass;
        this.native_1.classes_1.add_utx5q5_k$(newClass);
        var tmp = this.native_1;
        var tmp1_safe_receiver = this.get_parent_hy4reb_k$();
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_spacingForChildCornerRadii_uorqcm_k$();
        var tmp_0;
        var tmp_1 = tmp2_safe_receiver;
        if ((tmp_1 == null ? null : new (Dimension())(tmp_1)) == null) {
          tmp_0 = null;
        } else {
          tmp_0 = _Dimension___get_value__impl__urhqzr(tmp2_safe_receiver);
        }
        var tmp3_safe_receiver = tmp_0;
        var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.toString();
        tmp.setStyleProperty_wavvb3_k$('--parentSpacing', tmp4_elvis_lhs == null ? '0px' : tmp4_elvis_lhs);
        this.native_1.flushClasses_zcguoe_k$();
      }
      set_showOnPrint_2epyu7_k$(value) {
        this.showOnPrint_1 = value;
        if (value)
          this.native_1.classes_1.remove_cedx0m_k$('do-not-print');
        else
          this.native_1.classes_1.add_utx5q5_k$('do-not-print');
      }
    }
    initMetadataForClass($, 'NativeElement');
    NativeElementClass = $;
  }
  return NativeElementClass;
}
function get_native(_this__u8e3s4) {
  return _this__u8e3s4.get_underlyingNativeElement_vngz33_k$().native_1;
}
//region block: init
labelForIdCounter = 0;
//endregion
//region block: exports
export {
  NativeElement as NativeElement2p8z5z0r9meck,
  get_native as get_native16zxqjg6lrtlz,
  Job$cancel$ref as Job$cancel$ref2r8rkxbnqcz6i,
};
//endregion

//# sourceMappingURL=NativeElement.commonHtml.mjs.map
